import { AvailableLocale, Lang } from '@models/Lang'

export const langList: Lang[] = [
  {
    id: 0,
    name: 'Français',
    code: 'fr',
    flag: '🇫🇷',
  },
  {
    id: 1,
    name: 'English',
    code: 'en',
    flag: '🇬🇧',
  },
]

export const langsByCode: Record<AvailableLocale, Lang> = {
  fr: langList[0],
  en: langList[1],
}

export const langsAsOptions = langList.map((lang: Lang) => ({
  value: lang.code,
  label: `${lang.flag} ${lang.name}`,
}))

export const langsAsFlagOptions = langList.map((lang: Lang) => ({
  value: lang.code,
  label: `${lang.flag}`,
}))
